export default __webpack_public_path__ + "static/columnMenu-f88dec3f230a38487399dbbddda70a16.gif";